import { createStore } from '@vfde-sails/core';
// have to import separately, else scss mixes up import order
import './style.scss';
import app from 'Container/App';

createStore({});
app();
